"use strict";
/**
 * @file Created on Wed Jun 24 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");

var SimulationState_1 = require("./SimulationState");
/**
 * @author Tomas Leity
 */


var SimulationObject =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimulationObject, _DomainObject_1$Domai);

  /**
   * @param state Aggregated simulation state of simulation object.
   */
  function SimulationObject(state) {
    var _this;

    _classCallCheck(this, SimulationObject);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulationObject).call(this));
    _this.state = state;
    return _this;
  }
  /**
   * Checks simulation object for pending status. Includes only states that are assigned as empty simulation. (No simulation).
   *
   * @returns {boolean} Pending result check
   */


  _createClass(SimulationObject, [{
    key: "isPending",
    value: function isPending() {
      return !immutable_1.Set.of(SimulationState_1.SimulationState.Empty).has(this.state);
    }
    /**
     * Checks simulation object for pending status and returns result for acceptance.
     *
     * @returns {boolean} Pending result check
     */

  }, {
    key: "isPendingAcceptance",
    value: function isPendingAcceptance() {
      return immutable_1.Set.of(SimulationState_1.SimulationState.Pending).has(this.state);
    }
    /**
     * Gets names of all attributes that are simulated.
     */

  }, {
    key: "getNamesOfSimulatedAttributes",
    value: function getNamesOfSimulatedAttributes() {
      // PROMO-5 RFC 370: Only simulation values that differ from original values are not null
      return this.getValues().filter(function (simVal) {
        return simVal !== null;
      }).keySeq().toList();
    }
  }]);

  return SimulationObject;
}(DomainObject_1.DomainObject);

exports.SimulationObject = SimulationObject;